import "./Help.scss";
import ActionBar from "../../components/ActionBar/ActionBar";
import ActionBarButton from "../../components/ActionBar/ActionBarButton";
import "../../components/ActionBar/ActionBarButton.scss";
import "../../components/ActionBar/ActionBar.scss";
import BrandTitle from "../../components/BrandTitle/BrandTitle";

function Help() {
  return (
    <div className="help-wrapper">
      {/* <ActionBar>
        <ActionBarButton
          text="Documentation"
          iconName="menu_book"
        />
        <ActionBarButton
          text="Support"
          iconName="support_agent"
        />
      </ActionBar> */}

      <div className="help">
        <div className="help-content">
          <div className="help-header">
            <h1>
              <img
                src="/somigo_logo.svg"
                alt="SOMIGO Logo"
                className="help-logo"
              />
              Welcome to <BrandTitle fontSize={32} />
            </h1>
            <p className="help-subtitle">
              Your complete guide to getting started and mastering{" "}
              <BrandTitle fontSize={16} />
              's project management features
            </p>
          </div>

          {/* First Time Visitor Section */}
          <div className="first-time-banner">
            <div className="first-time-content">
              <span className="material-symbols-outlined wave-icon">
                waving_hand
              </span>
              <div className="first-time-text">
                <h3>First time here? You're in the right place!</h3>
                <p>
                  SOMIGO helps teams organize work with{" "}
                  <strong>Organizations</strong>,<strong> Projects</strong>, and{" "}
                  <strong>Tasks</strong>. Start by creating your first
                  organization below, or accept an invitation if someone already
                  invited you to join their team. Everything you need to know is
                  right here on this page.
                </p>
              </div>
            </div>
          </div>

          {/* Getting Started Video Section */}
          <div className="help-video-section">
            <div className="video-header">
              <span className="material-symbols-outlined">play_circle</span>
              <h2>Watch: Getting Started in 3 Minutes</h2>
            </div>
            <p className="video-subtitle">
              New to SOMIGO? Watch our quick tutorial to learn the basics
            </p>
            <div className="help-video-wrapper">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/U1tFGdum8nk"
                title="Getting Started with SOMIGO - Quick Tutorial"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Getting Started Section */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">rocket_launch</span>
              <h2>Getting Started</h2>
            </div>

            {/* Joined Organization Info */}
            <div className="help-card info-card">
              <div className="card-content full-width">
                <div className="info-banner">
                  <span className="material-symbols-outlined">mail</span>
                  <div>
                    <h4>Joined an Organization but No Projects?</h4>
                    <p>
                      If you've accepted an invitation to an organization but
                      don't see any projects, it means you haven't been added to
                      a project yet. Contact your organization admin to be added
                      to a project, or create your own project if you have admin
                      permissions.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Admin Role Info */}
            <div className="help-card info-card">
              <div className="card-content full-width">
                <div className="info-banner">
                  <span className="material-symbols-outlined">info</span>
                  <div>
                    <h4>About Admin Permissions</h4>
                    <p>
                      Some features are only available to users with the{" "}
                      <strong>Admin</strong> role in an organization. Admin
                      users can manage organization settings, create and edit
                      projects, invite members, and access the Dashboard. Look
                      for the <span className="admin-badge">Admin Only</span>{" "}
                      badge throughout this guide.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">domain</span>
              </div>
              <div className="card-content">
                <h3>1. Create Your First Organization</h3>
                <p>
                  Organizations are the top-level structure in SOMIGO. They
                  contain teams, projects, and members.
                </p>
                <ul>
                  <li>
                    Click the <strong>Organizations</strong> button (
                    <span className="inline-icon material-symbols-outlined">
                      domain
                    </span>
                    ) in the top bar
                  </li>
                  <li>Select "Create Organization" and enter a name</li>
                  <li>
                    <span className="admin-badge">Admin Only</span> Edit and
                    remove organizations you created
                  </li>
                  <li>
                    <span className="admin-badge">Admin Only</span> Invite team
                    members and assign roles
                  </li>
                </ul>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">folder_copy</span>
              </div>
              <div className="card-content">
                <h3>
                  2. Set Up Your First Project{" "}
                  <span className="admin-badge">Admin Only</span>
                </h3>
                <p>
                  Projects help you organize work into manageable units within
                  your organization.
                </p>
                <ul>
                  <li>
                    Click the <strong>Projects</strong> button (
                    <span className="inline-icon material-symbols-outlined">
                      folder_copy
                    </span>
                    ) in the top bar
                  </li>
                  <li>Click "Create New Project"</li>
                  <li>
                    Give your project a name and choose a color for easy
                    identification
                  </li>
                  <li>Assign team members to the project</li>
                  <li>Edit or remove projects as needed</li>
                </ul>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">
                  assignment_turned_in
                </span>
              </div>
              <div className="card-content">
                <h3>3. Create Tasks and Notes</h3>
                <p>
                  Start adding tasks to track your work and notes to document
                  important information.
                </p>
                <ul>
                  <li>
                    Navigate to the <strong>Tasks</strong> page from the sidebar
                  </li>
                  <li>
                    Use the <strong>Action Bar</strong> to create new tasks or
                    sections
                  </li>
                  <li>Add descriptions and assign team members</li>
                  <li>
                    Use the <strong>Notes</strong> page to create and organize
                    documentation
                  </li>
                </ul>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">dashboard</span>
              </div>
              <div className="card-content">
                <h3>
                  4. View Your Dashboard{" "}
                  <span className="admin-badge">Admin Only</span>
                </h3>
                <p>
                  Track project progress and get an overview of tasks and team
                  activity.
                </p>
                <ul>
                  <li>
                    Navigate to the <strong>Dashboard</strong> from the sidebar
                  </li>
                  <li>View project statistics and task completion rates</li>
                  <li>Monitor team performance and workload distribution</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Top Bar Guide */}
          <section className="help-section">
            <div className="section-header">
              <h2>Understanding the Top Bar</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <p>
                  The top bar provides quick access to essential features and
                  information:
                </p>
                <div className="feature-grid">
                  <div className="feature-item">
                    <span className="material-symbols-outlined">domain</span>
                    <h4>Organizations</h4>
                    <p>
                      Manage your organizations, create new ones, and switch
                      between them
                    </p>
                  </div>
                  <div className="feature-item">
                    <span className="material-symbols-outlined">group</span>
                    <h4>
                      People & Teams{" "}
                      <span className="admin-badge-small">Admin</span>
                    </h4>
                    <p>
                      View team members, create teams, and manage collaborators
                    </p>
                  </div>
                  <div className="feature-item">
                    <span className="material-symbols-outlined">
                      folder_copy
                    </span>
                    <h4>Projects</h4>
                    <p>
                      Access all projects, create new ones, and switch between
                      them
                    </p>
                  </div>
                  <div className="feature-item">
                    <span className="material-symbols-outlined">
                      manage_accounts
                    </span>
                    <h4>User Settings</h4>
                    <p>
                      Manage your profile, preferences, and account settings
                    </p>
                  </div>
                </div>
                <div className="info-box" style={{ marginTop: "20px" }}>
                  <span className="material-symbols-outlined">info</span>
                  <p>
                    <strong>Current Context:</strong> The text on the top left
                    side (left of the buttons) displays your{" "}
                    <strong>current project</strong> name, with your{" "}
                    <strong>current organization</strong> name shown below it.
                    This helps you stay oriented while working across multiple
                    projects and organizations.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Managing Projects */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">settings</span>
              <h2>Managing Projects</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>Project Features</h3>
                <div className="features-list">
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">palette</span>
                    <div>
                      <h4>Color Coding</h4>
                      <p>
                        Assign unique colors to projects for quick visual
                        identification in the interface
                      </p>
                    </div>
                  </div>
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">group_add</span>
                    <div>
                      <h4>
                        Team Collaboration{" "}
                        <span className="admin-badge-small">Admin</span>
                      </h4>
                      <p>
                        Add team members to projects and assign roles to control
                        access and permissions
                      </p>
                    </div>
                  </div>
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">edit</span>
                    <div>
                      <h4>
                        Project Settings{" "}
                        <span className="admin-badge-small">Admin</span>
                      </h4>
                      <p>
                        Edit project details, change colors, manage members, or
                        archive completed projects
                      </p>
                    </div>
                  </div>
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">
                      swap_horiz
                    </span>
                    <div>
                      <h4>Quick Switching</h4>
                      <p>
                        Use the projects dropdown to quickly switch between your
                        active projects
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Tasks and Notes */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">task_alt</span>
              <h2>Working with Tasks and Notes</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>Tasks</h3>
                <p>Tasks help you track work items and stay organized:</p>
                <ul className="styled-list">
                  <li>
                    <strong>Sections:</strong> Organize related tasks into
                    groups for better structure
                  </li>
                  <li>
                    <strong>Assignments:</strong> Assign tasks to team members
                    and track progress
                  </li>
                  <li>
                    <strong>Status Tracking:</strong> Mark tasks as To Do, In
                    Progress, or Completed
                  </li>
                </ul>

                <h3>Notes</h3>
                <p>
                  Notes provide a space for documentation and knowledge sharing:
                </p>
                <ul className="styled-list">
                  <li>
                    <strong>Rich Text Editing:</strong> Format your notes with
                    headings, lists, and styling
                  </li>
                  <li>
                    <strong>Note Groups:</strong> Organize notes by topic or
                    category
                  </li>
                  <li>
                    <strong>Collaboration:</strong> Share notes with team
                    members for better communication
                  </li>
                  <li>
                    <strong>Search:</strong> Quickly find notes using the search
                    functionality
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Post-Its */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">note_stack</span>
              <h2>Post-Its</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>Quick Notes and Reminders</h3>
                <p>
                  Post-Its are personal sticky notes that help you capture quick
                  thoughts, reminders, and ideas:
                </p>
                <ul className="styled-list">
                  <li>
                    <strong>Access Post-Its:</strong> Click the Post-It icon in
                    the top bar to open your post-it overlay
                  </li>
                  <li>
                    <strong>Create Post-Its:</strong> Click "Add new Post-It" to
                    create a new sticky note
                  </li>
                  <li>
                    <strong>Drag and Position:</strong> Grab the header or
                    footer (color buttons area) to drag post-its anywhere on the
                    overlay
                  </li>
                  <li>
                    <strong>Edit Content:</strong> Click on the content area to
                    edit your note text
                  </li>
                  <li>
                    <strong>Change Colors:</strong> Choose from 5 different
                    colors using the color buttons at the bottom when hovering
                  </li>
                  <li>
                    <strong>Pin Post-Its:</strong> Click the pin icon to make a
                    post-it visible across all pages - perfect for important
                    reminders!
                  </li>
                  <li>
                    <strong>Bring to Front:</strong> Click any post-it to bring
                    it to the front when multiple notes overlap
                  </li>
                  <li>
                    <strong>Delete:</strong> Click the delete icon in the header
                    to remove a post-it
                  </li>
                </ul>
                <p className="tip">
                  <strong>Tip:</strong> Use pinned post-its for things you need
                  to remember while working in different parts of the
                  application!
                </p>
              </div>
            </div>
          </section>

          {/* Checklists */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">checklist</span>
              <h2>Checklists</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>Personal To-Do Lists and Checklists</h3>
                <p>
                  Checklists are your personal task management tool, separate
                  from project tasks, helping you track individual to-dos and
                  create reusable templates:
                </p>
                <ul className="styled-list">
                  <li>
                    <strong>Access Checklists:</strong> Click the checklist icon
                    (
                    <span className="inline-icon material-symbols-outlined">
                      checklist
                    </span>
                    ) in the top bar to open your personal checklist manager
                  </li>
                  <li>
                    <strong>Create To-Do Lists:</strong> Create unique to-do
                    lists for different aspects of your work or personal life
                  </li>
                  <li>
                    <strong>Add Items:</strong> Add individual checklist items
                    to each list and mark them complete as you finish
                  </li>
                  <li>
                    <strong>Reorder Items:</strong> Drag and drop checklist
                    items to reorganize them by priority
                  </li>
                  <li>
                    <strong>Create Templates:</strong> Save frequently used
                    checklists as templates for quick reuse
                  </li>
                  <li>
                    <strong>Use Templates:</strong> Apply saved templates to new
                    to-do lists to save time on recurring tasks
                  </li>
                  <li>
                    <strong>Search & Filter:</strong> Quickly find specific
                    lists or items using the search functionality
                  </li>
                  <li>
                    <strong>Track Progress:</strong> See completion percentage
                    for each list at a glance
                  </li>
                </ul>
                <p className="tip">
                  <strong>Tip:</strong> Use checklists for personal tasks,
                  meeting agendas, daily routines, or any recurring workflows.
                  Templates are perfect for standardized processes you repeat
                  regularly!
                </p>
              </div>
            </div>
          </section>

          {/* Chat Feature */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">chat</span>
              <h2>Team Communication</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>Chat Feature</h3>
                <p>
                  When you have 2 or more people in your organization, the chat
                  feature becomes available for seamless team communication:
                </p>
                <ul className="styled-list">
                  <li>
                    <strong>Access the Chat:</strong> Look for the blue chat
                    button (
                    <span className="inline-icon material-symbols-outlined">
                      chat
                    </span>
                    ) in the bottom-right corner of the page
                  </li>
                  <li>
                    <strong>Direct Messages:</strong> Send private messages to
                    individual team members in your organization
                  </li>
                  <li>
                    <strong>Team Chats:</strong> Communicate with entire teams
                    for group discussions and coordination
                  </li>
                  <li>
                    <strong>Real-time Updates:</strong> Messages appear
                    instantly, keeping your team connected and informed
                  </li>
                </ul>
                <div className="info-box" style={{ marginTop: "20px" }}>
                  <span className="material-symbols-outlined">info</span>
                  <p>
                    <strong>Note:</strong> The chat button will only appear when
                    there are other active members in your organization. If
                    you're the only person in the organization, the chat feature
                    will be hidden until you invite and add more team members.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Tips and Best Practices */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">lightbulb</span>
              <h2>Tips & Best Practices</h2>
            </div>
            <div className="help-card tips-card">
              <div className="card-content full-width">
                <div className="tips-grid">
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>
                      Start with a clear organizational structure before adding
                      projects
                    </p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>
                      Use descriptive names for projects and tasks to improve
                      clarity
                    </p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>
                      Regularly update task statuses to keep everyone informed
                    </p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>
                      Use sections to break down large projects into manageable
                      pieces
                    </p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>
                      Leverage notes for meeting minutes, documentation, and
                      knowledge sharing
                    </p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>
                      Assign clear roles and permissions to maintain security
                      and organization
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Need More Help */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">support</span>
              <h2>Need More Help?</h2>
            </div>
            <div className="help-card contact-card">
              <div className="card-content full-width">
                <p>
                  If you have questions or need assistance, we're here to help:
                </p>
                <div className="contact-options">
                  <div className="contact-option">
                    <span className="material-symbols-outlined">email</span>
                    <div>
                      <h4>Email Support</h4>
                      <p>contact@somigo.io</p>
                    </div>
                  </div>
                  <div className="contact-option">
                    <span className="material-symbols-outlined">
                      bug_report
                    </span>
                    <div>
                      <h4>Report a Bug</h4>
                      <p>
                        Use the bug report feature in your dashboard to report
                        issues
                      </p>
                    </div>
                  </div>
                  <div className="contact-option">
                    <span className="material-symbols-outlined">lightbulb</span>
                    <div>
                      <h4>Feature Request</h4>
                      <p>
                        Have an idea? Submit a feature request to help us
                        improve
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Help;
